const BANNED_STRING_EDGE_CHARACTERS = ['-', '_']; // No need to ban spaces since they are removed by the trim() call

export const isValidFileName = (value) => { // Allow numbers, letters and hyphens (not at the beginning or end)
  return /^[a-zA-Z0-9-_ ]+$/.test(value) && 
    !BANNED_STRING_EDGE_CHARACTERS.includes(value[0]) && 
    !BANNED_STRING_EDGE_CHARACTERS.includes(value[value.length - 1]);
}

